<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-list-item dense>
    <v-list-item-icon v-if="icon">
      <v-progress-circular
        v-if="loading"
        indeterminate
        size="20"
      ></v-progress-circular>
      <v-icon v-else>{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-subtitle><a
        @click="download()"
        :class="loading ? 'disabled' : ''"
      >{{ text }}</a></v-list-item-subtitle>
  </v-list-item>
</template>

<script>
export default {
  name: "Downloadlink",
  data: () => ({
    loading: false,
  }),
  props: {
    icon: {
      required: false,
    },
    text: {
      required: true,
    },
    link: {
      required: true,
    },
    downloadName: {
      required: false,
    },
  },
  methods: {
    download() {
      if (this.loading) return;
      this.downloadName = this.downloadName ? this.downloadName : "download";

      this.loading = true;
      var _this = this;
      this.$axios({
        url: this.link,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          console.log(response);
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", this.downloadName + ".dxf");
          document.body.appendChild(fileLink);
          fileLink.click();
          _this.loading = false;
        })
        .catch((response) => {
          alert("Could not download file");
          console.log(response);
          _this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.disabled {
  cursor: not-allowed;
  color: gray;
}
</style>